import { mq } from '../styles/grid';

/**
 * @param {string} breakpoint
 * @param {string} mediaQuery
 * @returns {boolean}
 */
const isBreakpointInMediaQuery = (breakpoint, mediaQuery) => {
  switch (mediaQuery) {
    case mq.xl:
      return breakpoint === 'xl';
    case mq.lgDown:
      return breakpoint !== 'xl';
    case mq.mdDown:
      return breakpoint !== 'xl' && breakpoint !== 'lg';
    case mq.smDown:
      return breakpoint !== 'xl' && breakpoint !== 'lg' && breakpoint !== 'md';
    case mq.xs:
      return breakpoint === 'xs';
    default:
      return false;
  }
};

export default isBreakpointInMediaQuery;
